import { render, staticRenderFns } from "./dui-book-synopsis.vue?vue&type=template&id=60afe52d&scoped=true&"
import script from "./dui-book-synopsis.vue?vue&type=script&lang=js&"
export * from "./dui-book-synopsis.vue?vue&type=script&lang=js&"
import style0 from "./dui-book-synopsis.vue?vue&type=style&index=0&id=60afe52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60afe52d",
  null
  
)

export default component.exports